/* eslint-disable no-param-reassign */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import '../../css/pages/home.css';
import { toast } from 'react-toastify';
import moment from 'moment';
import SideNav from '../components/SideNav';
import Pagination from '../components/Pagination';
import TopNav from '../components/TopNav';
import { ExportCSV } from '../components/ExportCSV';
import AxiosClient from '../utils/AxiosClient';
import { fetchAgents } from '../actions/account';

class Report extends Component {
  constructor(props) {
    super(props);
    this.state = {
      transactions: [],
      agentsList: [],
      metrics: {},
      fromdate: '',
      todate: '',
      query: '',
      current_page: new URLSearchParams(props.location.search).get('page') || 1,
      limit: 10,
      agent: '',
      status: '',
      typeTitle: '',
      amount: 0,
    };
  }

  componentDidMount() {
    this.fetchReportStats();
    // this.fetchLoanStatus();
    fetchAgents().then((response) => this.setState({ agentsList: response.data.agents }));
  }

  // fetchLoanStatus = async () => {
  //   try {
  //     const client = await AxiosClient();
  //     const response = await client.get('business/report/loan/status');
  //     this.setState({ statusList: response.data.data || {} });
  //   } catch (error) {
  //     toast.error(error.response?.data?.message || error.response?.statusText);
  //   }
  // };

  fetchReportStats = async () => {
    try {
      const client = await AxiosClient();
      const response = await client.get('business/report/stats');
      this.setState({ metrics: response.data.data[0] || {} });
    } catch (error) {
      toast.error(error.response?.data?.message || error.response?.statusText);
    }
  };

  handleOnChange = (e) => this.setState({
    [e.target.name]: e.target.value,
  });

  handleExport = () => {
    let reportType = '';
   
    const {
      agent, fromdate, todate, status, amount,
    } = this.state;
    if (status !== 0) {
      if (+status === 1) reportType = 'Running_Loans';
      else if (+status === 5) reportType = 'PastDue_Loans';
      else if (+status === 2) reportType = 'Settled_Loans';

      this.setState({ loading: 'Processing' }, async () => {
        try {
          const client = await AxiosClient();
          const response = await client.get(`business/report/export?lenderid=${agent}&fromdate=${fromdate}&todate=${todate}&status=${status}&amount=${amount}`);
          const records = response.data.data;
          const exportData = [];
          records.forEach((element) => {
            exportData.push({
              Borrower: `${element.user.first_name} ${element.user.last_name}`,
              Phone_number: element.user.phone_number,
              ...element,
            });
          });

          if (response.data.status !== 'success') throw new Error(response?.data.message);
          const fileName = `${reportType}_${moment().format('YYYY-MM-DD hh:mm:ss tt')}`;
          ExportCSV({ csvData: exportData, fileName });
        } catch (error) {
          toast.error(
            error.response?.data?.message
            || error.response?.statusText
            || error.message
            || 'Seems like something went wrong with your request. Please try again.',
          );
        } finally {
          this.setState({ loading: false });
        }
      });
    }
  }

  handleSearchRecord = (page = 1, search = '', sortBy = 'created_on', sortDir = 'asc', limit = 10) => {
    const {
      agent, fromdate, todate, status, amount,
    } = this.state;
    // eslint-disable-next-line no-param-reassign
    if (+status === 1) sortBy = 'loans.disbursed_on';
    if (+status === 5) sortBy = 'loan_schedules.due_date';
    if (+status === 2) sortBy = 'loans.id';

    this.setState({ processing: 'Processing', transactions: [] }, async () => {
      try {
        const client = await AxiosClient();
        const response = await client.get(`business/report/search?page=${page}&limit=${limit}&sort_by=${sortBy}&sort_dir=${sortDir}&search=${search}&search_fields=users.first_name,users.last_name,users.phone_number,users.email&lenderid=${agent}&fromdate=${fromdate}&todate=${todate}&status=${status}&amount=${amount}`);

        const records = response.data.data;
        this.setState({
          transactions: records.loans,
          current_page: records.page_info.page,
          total: records.page_info.total,
        });
        if (response.data.status !== 'success') throw new Error(response?.data.message);
      } catch (error) {
        toast.error(
          error.response?.data?.message
          || error.response?.statusText
          || error.message
          || 'Seems like something went wrong with your request. Please try again.',
        );
      } finally {
        this.setState({ processing: false });
      }
    });
  };

  handlePageChange = (data) => {
    const { limit, query, status } = this.state;
    if (status !== '') {
      this.handleSearchRecord(data.currentPage, query, 'created_on', 'DESC', limit);
    }
  };

  onSearch = (e) => {
    const { limit } = this.state;
    this.setState({ query: e.currentTarget.value });
    this.handleSearchRecord(e.currentPage, e.currentTarget.value, 'created_on', 'DESC', limit);
  }

  handleReportSelect = (e) => {
    if (+e.currentTarget.value === 1) {
      this.setState({ typeTitle: '(Disbursment Date)', status: e.currentTarget.value });
    } else if (+e.currentTarget.value === 2) {
      this.setState({ typeTitle: '(Settled Date)', status: e.currentTarget.value });
    } else if (+e.currentTarget.value === 5) {
      this.setState({ typeTitle: '(Due Date)', status: e.currentTarget.value });
    }
  }

  getDueDate = (record) => {
    const tenor = parseFloat(record.tenor);
    const period = record.tenor_period;
    const disbursed_on = moment(record.disbursed_on);

    let futureMonth = '';
    if (period === 'months') {
      futureMonth = moment(disbursed_on).add(tenor, 'M');
      const futureMonthEnd = moment(futureMonth).endOf('month');

      if (disbursed_on.date() !== futureMonth.date() && futureMonth.isSame(futureMonthEnd.format('YYYY-MM-DD'))) {
        futureMonth = futureMonth.add(1, 'd');
      }
    } else if (period === 'days') futureMonth = moment(disbursed_on).add(tenor, 'd');

    return futureMonth.format('MMM DD, YYYY');
  }

  render() {
    const {
      transactions, metrics, agentsList, processing, total, current_page, limit, typeTitle, loading,
    } = this.state;
    return (
      <>
        <SideNav page="reports" />
        <main className="body-main">
          <div className="body-main__container">
            <TopNav page="report" />
            <section className="body-main__content">
              <div className="home">
                <div className="pageTitle d-lg-none">
                  <h3 className="pageTitle__header">Hello,&nbsp;</h3>
                  <p className="pageTitle__subheader">Welcome back!</p>
                </div>
                <div className="default-card home__stats">
                  <div className="row">
                    <div className="col-12 col-md-3 home__stats--group">
                      <div className="home__stats--group-content">
                        <p>Total Agent</p>
                        <h3>{metrics?.total_agents || 0}</h3>
                      </div>
                    </div>
                    <div className="col-12 col-md-3 home__stats--group">
                      <div className="home__stats--group-content">
                        <p>Total Loans</p>
                        <h3>{metrics?.total_loans || 0}</h3>
                      </div>
                    </div>
                    <div className="col-12 col-md-3 home__stats--group">
                      <div className="home__stats--group-content">
                        <p>Total Loan Disbursed</p>
                        <h3>
                          ₦
                          {metrics?.total_loan_disbursed || 0}
                        </h3>
                      </div>
                    </div>
                    <div className="col-12 col-md-3 home__stats--group">
                      <div className="home__stats--group-content">
                        <p>Total Earned</p>
                        <h3>
                          ₦
                          {metrics?.total_loan_earned || 0}
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row" style={{ marginTop: '20' }}>
                  <div className="col-12 col-xl-4">
                    <label className="form-label">Loan Status</label>
                    <select
                      className="form-control"
                      id="status"
                      name="status"
                      onChange={this.handleReportSelect}>
                      <option value="0">Select option</option>
                      <option value="1">Running</option>
                      <option value="2">Settled</option>
                      <option value="5">Past Due</option>
                    </select>
                    <br />
                  </div>
                  <div className="col-12 col-xl-4">
                    <label className="form-label">
                      From
                      {typeTitle}
                    </label>
                    <input
                      type="date"
                      name="fromdate"
                      onChange={this.handleOnChange}
                      className="form-control" />
                    <br />
                  </div>

                  <div className="col-12 col-xl-4">
                    <label className="form-label">
                      To
                      {typeTitle}
                    </label>
                    <input
                      type="date"
                      name="todate"
                      onChange={this.handleOnChange}
                      className="form-control" />
                    <br />
                  </div>
                </div>
                <div className="row" style={{ marginTop: '10px' }}>
                  <div className="col-12 col-xl-4">
                    <select
                      className="form-control"
                      id="agents"
                      name="agent"
                      onChange={this.handleOnChange}>
                      <option>Select agent</option>
                      {agentsList.map((element) => (
                        <option key={element.id} value={element.id}>
                          {element.first_name}
                          {' '}
                          {element.last_name}
                        </option>
                      ))}
                    </select>
                    <br />
                  </div>
                  <div className="col-12 col-xl-4">
                    <input
                      type="number"
                      name="amount"
                      placeholder="Amount greater than(Principal)"
                      onChange={this.handleOnChange}
                      className="form-control" />
                    <br />
                  </div>
                  <div className="col-12 col-xl-4">
                    <div>
                      <button
                        type="button"
                        onClick={() => this.handleSearchRecord()}
                        className="btn btn-primary"
                        disabled={processing}>
                        {processing ? 'Processing...' : 'Search'}
                      </button>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <div className="row my-4">
                      <div className="col-12">
                        <div className="filter-and-search">
                          <div className="filter-box d-flex">
                            <div className="search-box">
                              <input
                                type="search"
                                className="form-control"
                                placeholder="Search by name"
                                onInput={(e) => e.currentTarget.value === '' && this.onSearch(e)}
                                onKeyDown={(e) => e.key === 'Enter' && this.onSearch(e)} />
                            </div>

                          </div>
                          <div className="filter-and-search d-flex justify-content-end">
                            <div className="button-box">
                              <button
                                type="button"
                                onClick={() => this.handleExport()}
                                className="btn btn-primary"
                                disabled={loading}>
                                {loading ? 'Loading...' : 'Export'}
                              </button>

                            </div>
                          </div>
                        </div>
                        <div className="default-card page-table">
                          <div className="table-responsive">
                            <table className="table table-hover">
                              <thead>
                                <tr>
                                  <th className="reference">Borrower</th>
                                  <th className="reference">Phone Number</th>
                                  <th className="reference">Principal</th>
                                  <th className="amount">Interest</th>
                                  <th className="amount">Tenor</th>
                                  <th className="amount">Date Disbursed</th>
                                  <th className="amount">Due Date</th>
                                  <th className="narration">Amount Due</th>
                                  <th className="narration">Amount Paid</th>
                                </tr>
                              </thead>
                              <tbody>
                                {transactions.map((rec) => (
                                  <tr className="text-nowrap" key={rec.id}>
                                    <td>
                                      {rec.user.first_name}
                                      {' '}
                                      {rec.user.last_name}
                                    </td>
                                    <td>{rec?.user.phone_number}</td>
                                    <td className="text-nowrap">{Number(rec?.loan_amount).toLocaleString()}</td>
                                    <td className="text-nowrap">{Number(rec?.interest).toLocaleString()}</td>
                                    <td className="text-nowrap">
                                      {rec.tenor}
                                      {' '}
                                      {rec.tenor_period}
                                    </td>
                                    <td className="text-nowrap">{moment(rec?.disbursed_on).format('MMM DD, YYYY')}</td>
                                    <td>{this.getDueDate(rec)}</td>
                                    <td className="text-nowrap">{Number(rec?.amount_due).toLocaleString()}</td>
                                    <td className="text-nowrap">{Number(rec?.paid_to_lender).toLocaleString()}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                            <Pagination
                              totalRecords={total}
                              pageLimit={limit}
                              pageNeighbours={1}
                              onPageChanged={(e) => this.handlePageChange(e)}
                              initialPage={current_page} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>
      </>
    );
  }
}

export default Report;
